export const CREDIT_CARD_PROVIDERS = {
  VISA: 'Visa',
  MASTERCARD: 'Mastercard',
  AMEX: 'American Express',
  DISCOVER: 'Discover',
}

export const CREDIT_CARD_STARTING_DIGITS = {
  3: CREDIT_CARD_PROVIDERS.AMEX,
  4: CREDIT_CARD_PROVIDERS.VISA,
  5: CREDIT_CARD_PROVIDERS.MASTERCARD,
  6: CREDIT_CARD_PROVIDERS.DISCOVER,
}

export const CREDIT_CARD_PROVIDERS_CVV_LENGTH = {
  [CREDIT_CARD_PROVIDERS.AMEX]: 4,
  [CREDIT_CARD_PROVIDERS.VISA]: 3,
  [CREDIT_CARD_PROVIDERS.MASTERCARD]: 3,
  [CREDIT_CARD_PROVIDERS.DISCOVER]: 3,
}
